import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { getURLSegment } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

const UserDetails = observer(class UserDetails extends React.Component {
  componentWillMount() {
    const userSid = getURLSegment(this, 3);

    this.props.store.EnrollmentStore.getUser(userSid);
  }

  render() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    const { user } = this.props.store.EnrollmentStore;

    if(!SessionStore.loading) {
      return (
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{user.lastName}, {user.firstName}</h1>
            </div>
          </header>

          <div className="panel--brief">
            <ul className="data--alt">
              <li>
                <strong className="subtitle">{translation.email}</strong>
                <p>{user.email}</p>
              </li>
              {user.mobilePhone &&
                <li>
                  <strong className="subtitle">{translation.mobile_phone}</strong>
                  <p>{user.mobilePhone}</p>
                </li>
              }
              {user.homePhone &&
                <li>
                  <strong className="subtitle">{translation.home_phone}</strong>
                  <p>{user.homePhone}</p>
                </li>
              }
              <li>
                <strong className="subtitle">{translation.address}</strong>
                <p>{user.address}</p>
              </li>
            </ul>
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('UserDetails')(UserDetails);


// WEBPACK FOOTER //
// ./src/app/components/Modules/UserDetails.js